var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.c_class],on:{"click":function($event){return _vm.triggerClick()}}},[(!_vm.c_loading)?_c('span',[_vm._v(_vm._s(_vm.c_text))]):_vm._e(),(_vm.c_loading)?_c('loading',{attrs:{"reverse":_vm.c_loading_reverse}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }